import { NgModule } from '@angular/core';
import { ApxFormGroupDirective } from './form.directive';
import { ApxFormFieldComponent } from './form-field.component';

/**
 * Forms module migrated from @por/apex APEX library.
 * Renamed to PorFormsModule to avoid collision with Angular's native FormsModule.
 * All component names remain with "Apx" prefix (ApxFormFieldComponent, ApxFormDirective, etc.).
 * @public
 */
@NgModule({
    imports: [ApxFormGroupDirective, ApxFormFieldComponent],
    exports: [ApxFormGroupDirective, ApxFormFieldComponent]
})
export class PorFormsModule {}

// Re-export components for barrel exports
export { ApxFormGroupDirective } from './form.directive';
export { ApxFormFieldComponent } from './form-field.component';
